import useMobile from 'hooks/useMobile';
import { usePopupContext } from './PopupContextProvider';
import { Modal } from 'react-bootstrap';
import { Button, Image, Link } from 'components/common';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { useCallback, useState } from 'react';
import { routePaths } from 'appConfig';

const ReferralIncentivePopup = () => {
  const {
    referralCode,
    showReferralIncentivePopup,
    dismissReferralIncentivePopup,
    snoozeReferralIncentivePopup,
  } = usePopupContext();

  const isMobile = useMobile();
  const [copied, setCopied] = useState(false);

  const onDismissPopup = useCallback(() => {
    dismissReferralIncentivePopup();
    const timer = setTimeout(() => {
      snoozeReferralIncentivePopup();
    }, 300);

    return () => clearTimeout(timer);
  }, [dismissReferralIncentivePopup, snoozeReferralIncentivePopup]);

  return (
    <Modal
      backdrop="static"
      show={showReferralIncentivePopup}
      centered
      onHide={onDismissPopup}
      size="lg"
      className="tw-p-0"
    >
      <Modal.Body className="tw-p-0">
        <div className="md:tw-flex tw-relative tw-w-full">
          <div
            className={
              isMobile
                ? 'tw-hidden'
                : 'tw-w-full md:tw-w-[40%] md:tw-flex-shrink-0 tw-h-[36rem] md:tw-h-auto tw-relative'
            }
          >
            <Image
              src="/assets/images/popups/referral-incentive.png"
              alt="Referral Incentive"
              width={1500}
              height={2121}
              priority
              layout={isMobile ? 'fill' : 'responsive'}
              className="tw-w-full tw-h-full tw-object-cover tw-object-[50%_15%] md:tw-object-center"
            />
          </div>
          <div className="tw-w-full md:tw-flex-1 tw-px-8 tw-py-8 md:tw-py-28 tw-flex tw-flex-col tw-justify-center tw-items-center tw-relative">
            <div className="tw-flex tw-flex-col tw-space-y-8 tw-max-w-2xl tw-w-full">
              <div className="tw-flex tw-flex-col tw-space-y-4">
                <h1 className="tw-font-therebrat tw-text-[5.5rem] md:tw-text-[6.75rem] tw-font-medium tw-tracking-wide tw-mb-0 tw-text-center tw-leading-none">
                  Enjoy 10% OFF
                </h1>
              </div>
              <p className="tw-text-center tw-mb-0 tw-leading-tight tw-text-[#333] tw-text-2xl">
                by giving your friends{' '}
                <strong>$10 Off + FREE Delivery</strong>
                <br />
                on their first Yummy Bros order!”
              </p>
              <div className="tw-flex tw-justify-center tw-gap-4">
                <CopyToClipboard
                  text={referralCode}
                  onCopy={() => {
                    setCopied(true);

                    const timer = setTimeout(() => {
                      setCopied(false);
                      onDismissPopup();
                    }, 1000);

                    return () => clearTimeout(timer);
                  }}
                >
                  <Button className="tw-uppercase tw-text-[1.1rem] md:tw-text-[1.25rem] tw-flex-1 tw-w-full tw-whitespace-nowrap">
                    <>
                      {copied ? 'Copied!' : 'Copy My Referral Link'}
                    </>
                  </Button>
                </CopyToClipboard>
                <Link to={routePaths.USER_REFER_A_FRIEND}>
                  <Button
                    className="tw-flex-1 tw-uppercase tw-text-[1.1rem] md:tw-text-[1.25rem] tw-min-w-0 tw-w-full tw-text-[#666] tw-whitespace-nowrap"
                    color="dark"
                    variant="outlined"
                    onClick={onDismissPopup}
                  >
                    <>How does it work?</>
                  </Button>
                </Link>
              </div>
            </div>
          </div>
        </div>
        <button
          title="Close (Esc)"
          type="button"
          className="mfp-close tw-top-2 tw-right-2 tw-text-[1.5rem]"
          onClick={onDismissPopup}
        >
          <span>×</span>
        </button>
      </Modal.Body>
    </Modal>
  );
};

export default ReferralIncentivePopup;
